import { render, staticRenderFns } from "./UpsellItem.vue?vue&type=template&id=d80c4d74&"
import script from "./UpsellItem.vue?vue&type=script&lang=js&"
export * from "./UpsellItem.vue?vue&type=script&lang=js&"
import style0 from "./UpsellItem.vue?vue&type=style&index=0&id=d80c4d74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports